import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  { key: 'inspecte_1', icon: 'ri-home-5-line' },
  { key: 'inspecte_2', icon: 'ri-fire-line' },
  { key: 'inspecte_3', icon: 'ri-windy-line' },
  { key: 'inspecte_4', icon: 'ri-drop-line' },
  { key: 'inspecte_5', icon: 'ri-building-line' },
  { key: 'inspecte_6', icon: 'ri-error-warning-line' },
  { key: 'inspecte_7', icon: 'ri-time-line' },
  { key: 'inspecte_8', icon: 'ri-calculator-line' },
];

export default function CeQuOnInspecte() {
  const { t } = useTranslation('inspection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="inspecte" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('inspecte_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 bg-white rounded-xl transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 80 + 200}ms` }}
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-copper/10">
                <i className={`${item.icon} text-copper text-lg`} />
              </div>
              <span className="text-slate-primary font-medium text-sm leading-snug">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}